/* ================================================== */
/* FLICKITY > Init > shortly accessibility
/* ================================================== */

function flickityAccessibility() {
	if ($('html').attr('lang') == 'fr') {
		var ariaLabel = ['Aller à la page', 'du diaporama'];
	} else if ($('html').attr('lang') == 'en') {
		var ariaLabel = ['Go to page', 'of the slideshow'];
	}

	$('.flickity-page-dots').each(function(index, element){
		$('.dot', element).each(function(indexDot, elementDot){
			$(elementDot).attr({
				'tabindex'  : '0',
				'role'      : 'button',
				'aria-label': ariaLabel[0] + ' ' + (indexDot + 1) + ' ' + ariaLabel[1]
			});
		});
	});
}

$(window).on('resize orientationchange', function(){
	flickityAccessibility();
});


/* ================================================== */
/* FLICKITY > Init > dots accessibility
/* ================================================== */

function flickityDotsAccessibility($carousel) {
	$(document).on('keydown', '.flickity-page-dots .dot', function(event) {
		var $focusedElement = $(':focus');
		if (event.which === 13 && $focusedElement.length) {
			var index = $(this).index();
			$carousel.flickity('select', index );
		}
	});
}


/* ================================================== */
/* FLICKITY > Init > controls
/* ================================================== */

function flickityControls($carousel) {
	var $controls = $('.controls', $carousel),
		dataClass = '.data';

	$controls.on('click', function() {

		if ($controls.attr('data-mode') == 'isPlaying') {

			$controls.attr('data-mode', 'isPaused');
			$(dataClass, $controls).html($(dataClass, $controls).data('play'));
			$carousel.flickity('stopPlayer');

		} else if ($controls.attr('data-mode') == 'isPaused') {

			$controls.attr('data-mode', 'isPlaying');
			$(dataClass, $controls).html($(dataClass, $controls).data('pause'));
			$carousel.flickity('playPlayer');

		}

	});
}